import { useEffect, useRef } from 'react';
import { useHistoryConversationStore, type HistoryConversationActionSource } from '@/stores/history-conversation';

interface UseHistoryConversationSyncOptions {
  source: HistoryConversationActionSource;
  onSync: () => Promise<void> | void;
}

/** 订阅会话重命名/删除通知，在其它区域操作后刷新当前列表 */
function useHistoryConversationSync({ source, onSync }: UseHistoryConversationSyncOptions) {
  const version = useHistoryConversationStore((state) => state.version);
  const lastChange = useHistoryConversationStore((state) => state.lastChange);
  const skippedInitialVersionRef = useRef(false);
  // 避免 reload 引用变化误触发同步（如搜索改 params 导致 reload 重建）
  const onSyncRef = useRef(onSync);
  onSyncRef.current = onSync;

  useEffect(() => {
    if (!skippedInitialVersionRef.current) {
      skippedInitialVersionRef.current = true;
      return;
    }
    if (!lastChange || lastChange.source === source) {
      return;
    }
    void onSyncRef.current();
  }, [version, lastChange, source]);
}

export default useHistoryConversationSync;
